import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { AttendanceStateClass } from "./interfaces/AttendanceStateClass";
import fetchAPI from "../../common/fetchAPI";
import { format } from 'date-fns';
import fetchTimeliveAPI from "../../common/fetchTimeliveAPI";

const initialState: AttendanceStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    attendanceList: [],
    employeeList: [],
    isAllowedLocationInWeb: false,
    Latitude: "",
    Longitude: "",
    shiftName: "",
    optionEmployeeNameValueAttendance: "0",
    optionEmployeeNameTextAttendance: "All",
    startDateAttendance: new Date().toISOString(),
    // startDateAttendance: (() => {
    //     const newDate = new Date();
    //     newDate.setDate(newDate.getDate() - 15); // Subtract 1 day
    //     return newDate.toISOString();
    // })(),
    // endDateAttendance: (() => {
    //     const newDate = new Date();
    //     newDate.setDate(newDate.getDate() + 15); // Add 10 day
    //     return newDate.toISOString();
    // })(),
    endDateAttendance: new Date().toISOString(),
    attendanceDetailList: [],
    breakList: [],
    // resultId: "0",
    resultId: 0,
    CanStartBreak: false,
    CanEndBreak: false,
    CanCheckOut: false,
    accountEmployeeAttendanceId: null,
    isPermissionOfAdd: false,
    isPermissionOfEdit: false,
    isPermissionOfDelete: false,
    serverBaseUrl: "",
    currentPage: 1,
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    startRec: 0,
    search: '',
    isSearch: false,
    start: 0,
    sortOrder: 'asc',
    sortColumn: '3',
    recordsFiltered: 0,
    columnIndex: 0,
    direction: "asc",
    locationLoader: false,
    AccountEmployeeAttendanceDetails: [],
    AccountEmployeeAttendanceList: [],
    AccountAttendanceGeofenceLocationDetail: [],
    AttendanceTyeList: [],
    ActiveBreakId: ""
}

interface IThunkApi {
    state: {
        attendance: AttendanceStateClass
    }
}

export const getAccountEmployeesForDropDownAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Attendance/v2/getAccountEmployeesForDropDown",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Attendance/GetAccountEmployeesForDropDown", "Get", "", true);
            const json = response.json();
            return json;
        }
    )

export const getEmployeeAttendanceByEmployeeIdAndDateRangeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/getEmployeeAttendanceByEmployeeIdAndDateRange",
        async (arg, thunkApi) => {
            const { StartDate, EndDate, AccountEmployeeIds } = arg;
            const { startRec, search, pageNo, pageSize, sortOrder, sortColumn } = thunkApi.getState().attendance;
            const response = await fetchAPI(`api/v2/Attendance/DateRange?page=${pageNo}&pageSize=${pageSize}&start=${startRec}&Order=${sortColumn}&OrderDir=${sortOrder}&search=${search}&StartDate=${StartDate}&EndDate=${EndDate}&AccountEmployeeIds=${AccountEmployeeIds}`, "GET", "", true);
            const json = response.json();
            return json;
        }
    )

export const getAttendanceDetailByAccountEmployeeIdAndDateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/getAttendanceDetailByAccountEmployeeIdAndDate",
        async (arg, thunkApi) => {
            const { AccountEmployeeId, AttendanceDate, AttendanceMode } = arg;
            // const date = new Date(AttendanceDate);
            // const formattedDate = format(date, 'yyyy-MM-dd');
            const response = await fetchAPI(`api/v2/Attendance/Detail/${AccountEmployeeId}/${AttendanceDate}/${AttendanceMode}`, "GET", "", true);
            const json = response.json();
            return json;
        }
    )

export const getLastAttendanceAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/getLastAttendance",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/V2/Attendance/GetLastAttendance/" + arg, "GET", "", true)
            const json = response.json();
            return json;
        }
    )

export const checkPermissionsForAttendanceAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Attendance/v2/checkPermissionsForAttendance",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Attendance/Permissions", "GET", "", true);
            const json = response.json();
            return json;
        }
    )

export const getBreaksAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/getBreaks",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/V2/Attendance/Breaks/" + arg, "GET", "", true)
            const json = response.json();
            return json;
        }
    )

export const getShiftPermissionsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Shifts/v2/getShiftPermissions",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Shifts/ShiftPermissions", "GET", "", true)
            const json = response.json();
            return json;
        }
    )

export const addAttendanceManuallyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/addAttendanceManually",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Attendance/Manually", "POST", arg, true);
            const json = response.json();
            return json;
        }
    )

export const addAttendanceAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/addAttendance",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/V2/Attendance", "POST", arg, true)
            const json = response.json();
            return json;
        }
    )

export const updateAccountEmployeeAttendanceByAccountEmployeeAttendanceIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/v2/updateAccountEmployeeAttendanceByAccountEmployeeAttendanceId",
        async (arg, thunkApi) => {          
            const { AccountEmployeeAttendanceId, ...argWithoutId } = arg;
            
            const response = await fetchAPI("api/v2/Attendance/" + AccountEmployeeAttendanceId, "PUT", arg, true);
            const json = response.json();
            return json;
        }
    )

export const GetAccountEmployeeAttendanceListAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/Attendance/GetAccountEmployeeAttendanceList",
        async (arg, thunkApi) => {
            const { AccountEmployeeId, StartDate, EndDate,pageNumber = 1,pageSize=10, searchEmployeeId = '', accountDepartmentId = '', accountLocationId = '',status= '', employeeTypeId = '00000000-0000-0000-0000-000000000000', attendanceSourceId= '' } = arg;
            const response = await fetchTimeliveAPI(`api/Attendance/GetAccountEmployeeAttendanceList/${AccountEmployeeId}/${StartDate}/${EndDate}/${pageNumber}/${pageSize}?searchEmployeeId=${searchEmployeeId}&accountDepartmentId=${accountDepartmentId}&accountLocationId=${accountLocationId}&status=${status}&employeeTypeId=${employeeTypeId}&attendanceSourceId=${attendanceSourceId}`, "GET", "", true);
            const json = response.json();
            return json;
        }
    )

export const GetAccountEmployeeAttendanceViewDetails = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/Attendance/GetAccountEmployeeAttendanceActivity",
        async (arg, thunkApi) => {
            const { AccountEmployeeId, AttendanceDate } = arg;
            // const date = new Date(AttendanceDate);
            // const formattedDate = format(date, 'yyyy-MM-dd');
            const response = await fetchTimeliveAPI(`api/Attendance/GetAccountEmployeeAttendanceActivity/${AccountEmployeeId}/${AttendanceDate}`, "GET", "", true);
            const json = response.json();
            return json;
        }
    )
export const GetAttendanceGeofenceLocationActivity = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/Attendance/GetAttendanceGeofenceLocationActivity",
        async (arg, thunkApi) => {
            const { AccountEmployeeId, AttendanceDate } = arg;
            // const date = new Date(AttendanceDate);
            // const formattedDate = format(date, 'yyyy-MM-dd');
            const response = await fetchTimeliveAPI(`api/Attendance/GetAttendanceGeofenceLocationActivity/${AccountEmployeeId}/${AttendanceDate}`, "GET", "", true);
            const json = response.json();
            return json;
        }
    )

export const GeAttendanceTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Attendance/GeAttendanceType",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI("api/Attendance/GeAttendanceType", "GET", "", true)
            const json = response.json();
            return json;
        }
    )

export const AttendanceAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/Attendance",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI("api/Attendance", "POST", arg, true)
            const json = response.json();
            return json;
        }
    )

export const getLastAttendanceBySystemAttendanceIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Attendance/GetLastAttendance",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI("api/Attendance/GetLastAttendance/" + arg, "GET", "", true)
            const json = response.json();
            return json;
        }
    )
    function toUtcWithoutMilliseconds(dateString: string): string {
        const date = new Date(dateString);
        return date.toISOString().split('.')[0] + 'Z';
    }

const attendanceSlice = createSlice({
    name: "attendance",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        setOptionEmployeeNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionEmployeeNameValueAttendance = value;
            state.optionEmployeeNameTextAttendance = label;
        },
        setDateRangeValue: (state, action) => {          
            const { startDate, endDate } = action.payload;
            state.startDateAttendance = startDate;
            state.endDateAttendance = endDate;
        },
        selectedState: (state, action) => {
            const newState = [...state.employeeList];
            const { values } = action.payload;
            newState.forEach((item: any) => {
                item.isSelected = 0;
            });
            values.forEach((selectedValue: any) => {
                const selectedItem = newState.find(
                    (item: any) => item.value == selectedValue
                );
                if (selectedItem) {
                    selectedItem.isSelected = 1;
                }
            });
            state.employeeList = newState;
        },
        selectedSingleSelectState: (state, action) => {
            const newState = [...state.employeeList];
            const { value } = action.payload;
            newState.forEach((item: any) => {
                if (item.value === value) {
                    item.isSelected = 1;
                }
                else {
                    item.isSelected = 0;
                }
            });
            state.employeeList = newState;
        },
        setSelectedTimeIn: (state, action) => {
            const { AccountEmployeeAttendanceId, TimeIn } = action.payload;
            const currentindex = state.attendanceDetailList.findIndex((item) => item.AccountEmployeeAttendanceId == AccountEmployeeAttendanceId);
            const newArray = [...state.attendanceDetailList];
            newArray[currentindex] = { ...newArray[currentindex], TimeIn: TimeIn };
            state.attendanceDetailList = newArray;
        },
        setSelectedTimeOut: (state, action) => {
            const { AccountEmployeeAttendanceId, TimeOut } = action.payload;
            const currentindex = state.attendanceDetailList.findIndex((item) => item.AccountEmployeeAttendanceId == AccountEmployeeAttendanceId);
            const newArray = [...state.attendanceDetailList];
            newArray[currentindex] = { ...newArray[currentindex], TimeOut: TimeOut };
            state.attendanceDetailList = newArray;
        },
        setAttendanceData: (state, action) => {
            // state.resultId = "0";
            state.resultId = 0;
            state.CanCheckOut = false;
            state.CanEndBreak = false;
            state.CanStartBreak = false;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSortConfig: (state, action) => {
            const { columnIndex, direction } = action.payload;
            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';
            }
            state.direction = ndirection;
            state.columnIndex = columnIndex;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },

        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateLoader:(state,action)=>{
            state.isLoading = action.payload;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeesForDropDownAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeesForDropDownAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                state.employeeList = payload;
                state.optionEmployeeNameValueAttendance = state.employeeList.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ')
                state.selectedRecord = {};
            })
            .addCase(getAccountEmployeesForDropDownAsync.rejected, (state) => {
                state.status = "failed";
            })
            .addCase(getEmployeeAttendanceByEmployeeIdAndDateRangeAsync.pending, (state) => {
                state.status = "loading";
                //state.isLoading = true;
            })
            .addCase(getEmployeeAttendanceByEmployeeIdAndDateRangeAsync.fulfilled, (state, { payload }) => {
                // state.status = "idle";
                // if (Object.keys(JSON.parse(payload.Data.data)).length === 0) {
                //     state.attendanceList = [];
                // } else {
                //     state.attendanceList = JSON.parse(payload.Data.data);
                //     state.attendanceList.map((item: any) => {
                //         item.isSelected = 0
                //     });
                // }
                state.status = "idle";
                let tempArray = [];
               try {
                   tempArray = payload.Data?.data ? JSON.parse(payload.Data.data) : [];
               } catch (error) {
                   console.error("Invalid JSON in payload.Data.data:", payload.Data.data);
                   tempArray = [];
               }
               if (tempArray.length === 0) {
                   state.attendanceList = [];
               } else {
               state.attendanceList = tempArray.map((item: any) => ({
                       ...item,
                       isSelected: 0,
                   }));
               }

                state.selectedRecord = {};
                state.currentPage = payload.Data.currentPage;
                state.start = payload.Data.start
                state.totalItems = payload.Data.recordsTotal;
                state.search = payload.Data.search;
                state.recordsFiltered = payload.Data.recordsFiltered;
                state.serverBaseUrl = payload.Data.serverBaseUrl;
                // state.pageSize = payload.Data.pageSize;
                state.isReload = false;
                state.isLoading = false;
            })
           
            .addCase(getEmployeeAttendanceByEmployeeIdAndDateRangeAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;
            })
            .addCase(getAttendanceDetailByAccountEmployeeIdAndDateAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAttendanceDetailByAccountEmployeeIdAndDateAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (payload.Data.length === 0) {
                    state.attendanceDetailList = [];
                } else {
                    state.attendanceDetailList = payload.Data;
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAttendanceDetailByAccountEmployeeIdAndDateAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false
            })
            .addCase(getShiftPermissionsAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getShiftPermissionsAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                state.shiftName = payload.Data[0].Name;
                if (payload.Data[0].AllowLocationInWeb == true) {
                    state.isAllowedLocationInWeb = true;
                }
                else {
                    state.isAllowedLocationInWeb = false;
                }
            })
            .addCase(getShiftPermissionsAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;
            })
            .addCase(checkPermissionsForAttendanceAsync.pending, (state) => {
                state.status = "loading";
                //state.isLoading = true;
            })
            .addCase(checkPermissionsForAttendanceAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                state.isPermissionOfAdd = payload.Data.isPermissionOfAdd;
                state.isPermissionOfEdit = payload.Data.isPermissionOfEdit;
                state.isPermissionOfDelete = payload.Data.isPermissionOfDelete;
            })
            .addCase(checkPermissionsForAttendanceAsync.rejected, (state) => {
                state.status = "failed";
            })
            .addCase(getBreaksAsync.pending, (state) => {
                state.status = 'loading';
                //state.isLoading = true;
            })
            .addCase(getBreaksAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (payload.Data.length === 0) {
                    state.breakList = [];
                } else {
                    state.breakList = payload.Data;
                }
                state.selectedRecord = {};
            })
            .addCase(getBreaksAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getLastAttendanceAsync.pending, (state) => {
                state.status = 'loading';
                //state.isLoading = true;
            })
            .addCase(getLastAttendanceAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                const { Id, Data } = payload;
                if (Data.EmployeeAttendance !== undefined && Data.EmployeeAttendance !== null) {
                    const { CanStartBreak, CanEndBreak, CanCheckOut, ActiveBreakId } = Data.EmployeeAttendance;
                    state.resultId = Id;
                    state.CanStartBreak = CanStartBreak;
                    state.CanEndBreak = CanEndBreak;
                    state.CanCheckOut = CanCheckOut;
                    state.ActiveBreakId = ActiveBreakId;
                }
                else {
                    // state.resultId = "0";
                    state.resultId = 0;
                    state.CanStartBreak = false;
                    state.CanEndBreak = false;
                    state.CanCheckOut = false;
                    state.ActiveBreakId = "";
                }
                state.selectedRecord = {};
            })
            .addCase(getLastAttendanceAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAttendanceManuallyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAttendanceManuallyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAttendanceManuallyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addAttendanceAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAttendanceAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAttendanceAsync.rejected, (state) => {
                state.status = 'failed';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(updateAccountEmployeeAttendanceByAccountEmployeeAttendanceIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountEmployeeAttendanceByAccountEmployeeAttendanceIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountEmployeeAttendanceByAccountEmployeeAttendanceIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountEmployeeAttendanceListAsync.pending,(state)=>{
                state.status = 'loading';
                state.isLoading = true;
                // state.isReload= true;
            })
            .addCase(GetAccountEmployeeAttendanceListAsync.fulfilled,(state, action)=>{
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = false;
                state.AccountEmployeeAttendanceList = action.payload?.Data || []
            })
            .addCase(GetAccountEmployeeAttendanceListAsync.rejected,(state)=>{
                 state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(GetAccountEmployeeAttendanceViewDetails.pending,(state)=>{
                state.status = 'loading';
                state.isLoading = true;
                state.isReload= true;
            })
            .addCase(GetAccountEmployeeAttendanceViewDetails.fulfilled,(state, action)=>{
                state.status = 'idle';
                state.isLoading = false;
                state.AccountEmployeeAttendanceDetails = action?.payload?.Data || [];
            })
            .addCase(GetAccountEmployeeAttendanceViewDetails.rejected,(state)=>{
                 state.status = 'failed';
                state.isLoading = false;
            })
              .addCase(GetAttendanceGeofenceLocationActivity.pending,(state)=>{
                state.status = 'loading';
                state.isLoading = true;
                state.isReload= true;
            })
            .addCase(GetAttendanceGeofenceLocationActivity.fulfilled,(state, action)=>{
                state.status = 'idle';
                state.isLoading = false;
                state.AccountAttendanceGeofenceLocationDetail = action?.payload?.Data || [];
            })
            .addCase(GetAttendanceGeofenceLocationActivity.rejected,(state)=>{
                 state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GeAttendanceTypeAsync.pending,(state)=>{
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GeAttendanceTypeAsync.fulfilled,(state, action)=>{
                state.status = 'idle';
                state.isLoading = false;
                state.AttendanceTyeList = action.payload.Data || [];
            })
            .addCase(GeAttendanceTypeAsync.rejected,(state)=>{
                state.status = 'failed';
                state.isLoading = false;
            })
             .addCase(AttendanceAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(AttendanceAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(AttendanceAsync.rejected, (state) => {
                state.status = 'failed';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getLastAttendanceBySystemAttendanceIdAsync.pending, (state) => {
                state.status = 'loading';
                //state.isLoading = true;
            })
            .addCase(getLastAttendanceBySystemAttendanceIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                const { Id, Data } = payload;
                if (Data.EmployeeAttendance !== undefined && Data.EmployeeAttendance !== null) {
                    const { CanStartBreak, CanEndBreak, CanCheckOut, ActiveBreakId } = Data.EmployeeAttendance;
                    state.resultId = Id;
                    state.CanStartBreak = CanStartBreak;
                    state.CanEndBreak = CanEndBreak;
                    state.CanCheckOut = CanCheckOut;
                    state.ActiveBreakId = ActiveBreakId;
                }
                else {
                    // state.resultId = "0";
                    state.resultId = 0;
                    state.CanStartBreak = false;
                    state.CanEndBreak = false;
                    state.CanCheckOut = false;
                    state.ActiveBreakId = "";
                }
                state.selectedRecord = {};
            })
            .addCase(getLastAttendanceBySystemAttendanceIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const { resetSelectedRecordObjectInState, setOptionEmployeeNameValue, setDateRangeValue, selectedState, selectedSingleSelectState, setSelectedTimeIn,
    setSelectedTimeOut, setAttendanceData, setPageSize, setSortConfig, updateIsLoading,updateSorting ,updatePagination,updateSearchPagination, updateLoader} = attendanceSlice.actions
export const AttendanceState = (state: RootState) => state.attendance
export default attendanceSlice.reducer